import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ServeAdbutler = ({ uid, id, adConfig, adButlerCustomStyle }) => {
  const adButlerContainerRef = useRef(null);

  useEffect(() => {
    if (adButlerContainerRef.current) {
      fetch(`https://servedbyadbutler.com/adserve/;MID=166135;setID=${id};uid=${uid};type=json`)
        .then((res) => res.json())
        .then((data) => {
          const placement = data.placements.placement_1;

          if (!placement) {
            return; // Exit early if no placement data
          }
          const container = adButlerContainerRef.current;

          const customStyleString = adButlerCustomStyle
            ? Object.entries(adButlerCustomStyle)
                .map(
                  ([key, value]) =>
                    `${key.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`)}: ${value}`,
                )
                .join('; ')
            : '';

          if (container) {
            // Use config size if available, fallback to placement size
            const width = adConfig?.size?.[0]?.[0] || placement.width || 320; // If we do not have a width 320 is common for mobile
            const imgStyles = `width: 100%; height: auto; max-width: ${width}px;${
              customStyleString ? ` ${customStyleString}` : ''
            }`;

            container.innerHTML = `
              <div 
                class="js-ad"
                style="overflow: hidden; margin: 0 auto; max-width: 100%;">
                <a href="${placement.redirect_url}" target="${placement.target}" rel="noopener">
                  <img 
                    src="${placement.image_url}" 
                    alt="${placement.alt_text || 'Advertisement'}"
                    style="${imgStyles}"
                  >
                </a>
              </div>
            `;

            // Optional: fire viewability pixel if provided
            if (placement.viewable_url) {
              const viewPixel = new Image();
              viewPixel.src = placement.viewable_url;
            }
          }
        })
        .catch(() => {
          const container = adButlerContainerRef.current;
          if (container) {
            container.style.display = 'none';
          }
        });
    }
  }, [id, uid, adConfig]);

  return <div ref={adButlerContainerRef} />;
};

ServeAdbutler.propTypes = {
  uid: PropTypes.string,
  id: PropTypes.string,
  adConfig: PropTypes.shape({
    size: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  }),
  adButlerCustomStyle: PropTypes.shape,
};

ServeAdbutler.defaultProps = {
  uid: null,
  id: null,
  adConfig: null,
  adButlerCustomStyle: null,
};

export default ServeAdbutler;
